import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';

import {
  calculateBatteryCapacity,
  setCalculatedBatteryCapacity,
} from './homebattery-capacity.actions';
import { selectHomebatteryQuestionnaireAnswers } from '../questionnaire';
import { selectHomeBatteryConsumptionEstimateValueState } from '../selectors';
import { handleBatteryCapacityCalculation } from './homebattery-capacity.helpers';

@Injectable()
export class HomebatteryCapacityEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  handleCalculateCapacity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(calculateBatteryCapacity),
      concatLatestFrom(() => [
        this.store.select(selectHomeBatteryConsumptionEstimateValueState),
        this.store.select(selectHomebatteryQuestionnaireAnswers),
      ]),
      map(([_, consumption, answers]) => {
        const capacity = handleBatteryCapacityCalculation(
          consumption as number,
          answers['hasSolarPanels'] as boolean,
          answers['contractType'] === 'Dynamisch contract'
        );

        return setCalculatedBatteryCapacity({
          calculatedBatteryCapacity: capacity,
        });
      })
    )
  );
}
